import React from "react";

const ActivityLogTable = ({ activityLog }) => {
  if (!activityLog || activityLog.length === 0) {
    return null;
  }

  const getActionIcon = (action) => {
    const icons = {
      SUBMITTED: "📝",
      IN_REVIEW: "👀",
      QUERY_RAISED: "⚠️",
      RESUBMITTED: "🔄",
      APPROVED: "✅",
      REJECTED: "❌",
      UPDATED: "✏️",
      STATUS_CHANGED: "🔄"
    };
    return icons[action] || "•";
  };

  const getActionLabel = (action) => {
    const labels = {
      SUBMITTED: "Submitted",
      IN_REVIEW: "In Review",
      QUERY_RAISED: "Query Raised",
      RESUBMITTED: "Resubmitted",
      APPROVED: "Approved",
      REJECTED: "Rejected",
      UPDATED: "Updated",
      STATUS_CHANGED: "Status Changed"
    };
    return labels[action] || action;
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  };

  const getRowClass = (action) => {
    if (action === 'QUERY_RAISED') return 'table-warning';
    if (action === 'APPROVED') return 'table-success';
    if (action === 'REJECTED') return 'table-danger';
    if (action === 'RESUBMITTED') return 'table-info';
    return '';
  };

  return (
    <div className="mb-4">
      <h6 className="mb-3">📋 Application Activity Log</h6>
      <div className="table-responsive">
        <table className="table table-hover table-sm">
          <thead className="table-light">
            <tr>
              <th style={{ width: '180px' }}>Date & Time</th>
              <th style={{ width: '150px' }}>Action</th>
              <th style={{ width: '120px' }}>By</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {activityLog.slice().reverse().map((log, idx) => (
              <tr key={idx} className={getRowClass(log.action)}>
                <td className="text-nowrap">
                  <small>{formatDate(log.timestamp)}</small>
                </td>
                <td>
                  <span className="badge bg-light text-dark border">
                    {getActionIcon(log.action)} {getActionLabel(log.action)}
                  </span>
                </td>
                <td>
                  <small className="text-muted">
                    {log.actorName || log.actor || 'System'}
                  </small>
                </td>
                <td>
                  <small>
                    {log.details && log.details.length > 100 
                      ? log.details.substring(0, 100) + '...' 
                      : log.details}
                  </small>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <style>{`
        .table-responsive {
          border: 1px solid #dee2e6;
          border-radius: 8px;
          overflow: hidden;
        }
        .table {
          margin-bottom: 0;
        }
        .table th {
          background-color: #f8f9fa;
          font-weight: 600;
          font-size: 0.875rem;
          border-bottom: 2px solid #dee2e6;
        }
        .table td {
          vertical-align: middle;
          padding: 0.75rem;
        }
        .table-hover tbody tr:hover {
          background-color: #f8f9fa;
        }
      `}</style>
    </div>
  );
};

export default ActivityLogTable;
